import React, { useContext, useEffect, useState } from "react";
import { ExpenseItemDto } from "../../../../dtos/catalogs/ExpenseItem/ExpenseItemDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import ExpenseItemDetailSkeleton from "./ExpenseItemDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import ExpenseItemDetailMain from "./ExpenseItemDetailMain";

interface IProps {
  model: ExpenseItemDto | null;
  modelUpdatedEvent: (newModel: ExpenseItemDto) => void;
}

interface ExpenseItemModel {
  id: string;
  name: string;
  uniqueCode?: string;
  createdDate?: Date;
  description?: string;
  accountId?: string;
}

export const ExpenseItemDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ExpenseItemModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("uniqueCode", model.uniqueCode);
      setValue("createdDate", model.createdDate);
      setValue("description", model.description);
      setValue("accountId", model.accountId);
      // setValue("analyticsTypeOfIncomeId", model.analyticsTypeOfIncomeId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: ExpenseItemModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: ExpenseItemDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <ExpenseItemDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
        <ExpenseItemDetailMain/>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
